import { Typography } from "@mui/material";
import { Box } from "@mui/system";
import { ReactNode } from "react";

export function CodeBlock({ children }: { children: ReactNode }) {
  return (
    <Box
      sx={{
        width: "100%",
        background: "#333",
        boxShadow: "1px 2px 10px inset #000",
        color: "green",
        padding: 4,
        fontFamily: "sans-serif",
        borderRadius: 5,
        textShadow: "1px 1px 20px rgba(255,255,255,0.2)",
      }}
    >
      <Typography variant="h5">{children}</Typography>
    </Box>
  );
}
